import React from 'react';
import './IntegrationsPanel.css';

const IntegrationsPanel = ({ filteredIntegrations, proofT }) => {
  // Helper function to translate focus descriptions
  const translateFocus = (focus) => {
    // Create a key from the focus text (lowercase, replace spaces with camelCase)
    const focusKey = focus.toLowerCase().replace(/\s+/g, '');
    const translationKey = `integrations.focus.${focusKey}`;
    const translated = proofT(translationKey);
    // If translation exists and is different from the key, use it; otherwise use original
    return translated && translated !== translationKey ? translated : focus;
  };

  return (
    <div className="tab-panel active">
      <div className="integrations-overview">
        <div className="integrations-intro">
          <h3>{proofT('integrations.intro.title')}</h3>
          <p>{proofT('integrations.intro.description')}</p>
          <div className="addon-types-explanation">
            <div className="addon-type-card chat-addon">
              <div className="addon-content">
                <div className="addon-header">
                  <h4>{proofT('integrations.addonTypes.chat.title')}</h4>
                  <span className="addon-badge">{proofT('integrations.addonTypes.chat.badge')}</span>
                </div>
                <p>{proofT('integrations.addonTypes.chat.description')}</p>
                <div className="addon-features">
                  <div className="feature-list">
                    <span className="feature-item">{proofT('integrations.addonTypes.chat.features.bookAppointments')}</span>
                    <span className="feature-item">{proofT('integrations.addonTypes.chat.features.checkAvailability')}</span>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="addon-type-card knowledge-addon">
              <div className="addon-content">
                <div className="addon-header">
                  <h4>{proofT('integrations.addonTypes.knowledge.title')}</h4>
                  <span className="addon-badge">{proofT('integrations.addonTypes.knowledge.badge')}</span>
                </div>
                <p>{proofT('integrations.addonTypes.knowledge.description')}</p>
                <div className="addon-features">
                  <div className="feature-list">
                    <span className="feature-item">{proofT('integrations.addonTypes.knowledge.features.businessAnalytics')}</span>
                    <span className="feature-item">{proofT('integrations.addonTypes.knowledge.features.customerInsights')}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div className="integrations-grid">
          {filteredIntegrations.length > 0 ? (
            filteredIntegrations.map((integration, index) => (
              <div key={index} className="integration-tile">
                <div className="tile-header">
                  <h4>{integration.name}</h4>
                  <div className="tile-status">
                    <span className="status-text">{proofT('integrations.status.comingSoon')}</span>
                  </div>
                </div>
                <p className="tile-description">{translateFocus(integration.focus)}</p>
                <div className="tile-tags">
                  <span className={`industry-tag ${integration.industry.toLowerCase()}`}>{proofT(`filters.industries.${integration.industry.toLowerCase()}`) || integration.industry}</span>
                  <div className="addon-icons">
                    {integration.addonTypes.map((type, typeIndex) => (
                      <div key={typeIndex} className={`addon-icon ${type}`} title={type === 'chat' ? proofT('integrations.tooltips.chatAddon') : proofT('integrations.tooltips.knowledgeAddon')}>
                        {type === 'chat' ? (
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M21 15C21 15.5304 20.7893 16.0391 20.4142 16.4142C20.0391 16.7893 19.5304 17 19 17H7L3 21V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H19C19.5304 3 20.0391 3.21071 20.4142 3.58579C20.7893 3.96086 21 4.46957 21 5V15Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            <path d="M13 8H7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            <path d="M17 12H7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          </svg>
                        ) : (
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M3 3V21H21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            <path d="M9 9L12 6L16 10L20 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            <path d="M9 15H12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            <path d="M9 18H16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          </svg>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="no-results">
              <p>{proofT('integrations.noResults')}</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default IntegrationsPanel;

